
import Vue from "vue";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import { DashboardBankData } from "@/utils/dashboard/dashboard-bank-data";
import { BankService } from "@/services";
import { BankType } from "@/models/base";
import { printHumanFloat } from "@/utils/pretty-print";

interface ISaldo {
	type:BankType;
	saldo:number;
}

export default Vue.extend({
	data(){
		return {
			saldos: [] as ISaldo[]
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		}
	},
	computed: {
		chartData():DashboardBankData{
			return this.item.Data as DashboardBankData;
		},
		colWidth():number {
			if (this.item.width > 1) {
				return 12 / Math.min(this.item.width, this.saldos.length);
			}
			return 12;
		},
		total():number{
			return this.saldos.map(a=>a.saldo).reduce((a,b)=>(b||0)+a);
		}
	},
	methods: {
		async fetch(){
			let types = BankService.getTypes();
			let saldos = [] as ISaldo[];
			for (let typeId of this.chartData.bankIds){
				let bankType = types.find(t=>t.ID == typeId);
				if (!bankType) return;
				let saldo = await BankService.getBalance(typeId);
				saldos.push({
					type: bankType,
					saldo,
				});
			}
			this.saldos = saldos;
		},
		printHumanFloat(val:number):string{
			return printHumanFloat(val);
		}
	},
	created(){
		this.fetch();
	},
	i18nEx: {
		componentPrefix: "views.HomeRoute"
	}
});
